const inlineSuggestCommitId = 'editor.action.inlineSuggest.commit';
const showPreviousInlineSuggestionActionId = 'editor.action.inlineSuggest.showPrevious';
const showNextInlineSuggestionActionId = 'editor.action.inlineSuggest.showNext';
export { inlineSuggestCommitId, showNextInlineSuggestionActionId, showPreviousInlineSuggestionActionId };
